import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React, { useContext, useEffect, useState } from "react";
import { Checkbox, Fade, FormControl, Grow, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import {Player} from "../../reckon-api";
import {useReferentialContext} from "../../Context";

export default function PlayerSelect(props: { value: Player|null; onChange: any, referential: Player[] }) {
    const [inputValue, setInputValue] = useState(props.value?.id);
    const [possibilities, setPossibilities] = useState([] as Player[]);
    const [clicked, setClicked] = useState(false);
    const [reload, setReload] = useState(true);


    const filterOptions = (inputValue: string) => {
        return props.referential.filter((player: Player) => player.id.toLowerCase().startsWith(inputValue.toLowerCase()));
    };

    const countPossibilities = (inputValue: any) => {
        const filteredOptions = filterOptions(inputValue);
        return filteredOptions.length;
    };

    const handleInputChange = (event: any, newInputValue: any) => {
        if (props.value && newInputValue !== props.value.id) {
            setInputValue(newInputValue);
            const numPossibilities = countPossibilities(newInputValue);
            setClicked(true);
            setPossibilities(numPossibilities < 1000 ? filterOptions(newInputValue) : []);
        }
    };
    const handleAutocompleteClick = () => {
        setClicked(true);
        if(inputValue){
            const numPossibilities = countPossibilities(inputValue);
            if (numPossibilities < 1000) {
                setPossibilities(filterOptions(inputValue));
            }
        }
    };

    const handleBlur = () => {
        setClicked(false);
        setPossibilities([]);
    };

    const handleValueChange = (event: any, player: Player|null) => {
        if (player) {
            setReload(false);
            setPossibilities([]);
            props.onChange(player ? player : null);
            setClicked(false);
        }
    };

    return (
        <FormControl sx={{ width: "300px", zIndex: 0 }}>
            <Autocomplete
                options={possibilities}
                value={props.value}
                onChange={handleValueChange}
                renderInput={(params) => {
                    setReload(true);
                    return (
                        props.value ?
                    <TextField
                        {...params}
                        label="Player"
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                                <Grow in={reload}
                                      style={{transformOrigin: "0 0 0"}} {...(reload ? {timeout: 2000} : {})}>
                                    <Stack direction={"row"}>
                                        {<Box>{props.value.current_team ? "" :  (props.value.last_team ? "Prev:" : "")}</Box>}
                                        {props.value.current_team || props.value.last_team ? (
                                            <Box
                                                component={"img"}
                                                src={`https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${25},w_${25}/v1/teamsLogo/${props.value.current_team ? props.value.current_team.split('_')[0] : props.value.last_team}.png`}
                                                sx={{
                                                    filter: "filter: invert(100%) hue-rotate(180deg) brightness(150%)",
                                                    mr: "10px",
                                                }}
                                            />
                                        ) : <></>}
                                        {params.InputProps.startAdornment}
                                    </Stack>
                                </Grow>
                            ),
                        }}
                    /> : <TextField {...params} label={"Player"} variant="outlined" />

                    );
                }}
                onInputChange={handleInputChange}
                open={clicked && possibilities.length > 0}
                onClick={handleAutocompleteClick}
                onBlur={handleBlur}
                getOptionLabel={(option: any) => {
                    return option.id;
                }}
                renderOption={(props, option, { selected }) => {
                    const team_img = option.current_team ? (
                        <Box component={"img"} src={`https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${25},w_${25}/v1/teamsLogo/${option.current_team.split('_')[0]}.png`}
                            sx={{ filter: "filter: invert(100%) hue-rotate(180deg) brightness(150%)",  mr: "10px",}} />
                    ) : (
                        <></>
                    );

                    return (
                        <Box>
                            <li {...props}>
                                {team_img}
                                {option.id}
                            </li>
                        </Box>
                    );
                }}
                ListboxProps={{ className: "scrollable" }}
            />
        </FormControl>
    );
}


